<template>
  <v-container class="beneficios">
    <v-container>
      <v-card
        class="py-4 px-2 auth-content"
        tile
      >
        <v-form
          v-model="valid"
          ref="form"
          autocomplete="no"
        >
          <PageTitle
            icon="mdi-pencil-box-outline"
            main="Assistência Social"
            sub="Cadastro de auxílio"
            home="/social"
          />
          <input
            id="user-id"
            type="hidden"
            v-model="beneficio.usuario"
          />
          <input
            id="beneficio-uuid"
            type="hidden"
            v-model="beneficio.uuid"
          />
          <v-row>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="beneficio.id"
                label="Código do pedido"
                dense
                outlined
                @change="loadPedido()"
              >
                <v-icon
                  slot="append"
                  color="success"
                  large
                  @click="loadDialog"
                >
                  mdi-magnify
                </v-icon>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
              v-if="codigo"
            >
              <v-checkbox
                v-model="beneficio.inativar"
                label="Inativar Pedido?"
                color="success"
                v-show="mode === 'save'"
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-if="codigo"
            >
              <v-text-field
                v-model="beneficio.protocolo"
                label="Nº do protocolo"
                type="text"
                disabled
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-if="codigo"
            >
              <v-autocomplete
                v-model="beneficio.uid_situacao"
                :items="status"
                disabled
                dense
                label="Situação atual do processo"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="2"
              v-if="codigo"
            >
              <h5>Total da renda bruta <br />R${{ formatPrice(total) }}</h5>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="3"
              lg="2"
              class="mr-0 pr-0"
            >
              <v-text-field
                class="codigo mr-0"
                v-model="beneficio.uid_pessoa"
                label="Código..."
                dense
                outlined
                flat
                @change="loadPedidoPessoaId()"
              >
                <v-icon
                  class="v-icon-btn-outer"
                  slot="append-outer"
                  color="white"
                  large
                  @click="loadFtPessoa"
                >
                  mdi-magnify
                </v-icon>
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="5"
              lg="7"
              class="mx-0 px-0"
            >
              <v-text-field
                class="v-busca-nome ml-0"
                v-model="beneficio.solicitante"
                :loading="loading"
                aria-autocomplete="none"
                :search-input.sync="search"
                label="Nome do Solicitate"
                outlined
                dense
                @keyup.native="loadSeach()"
              >
                <v-icon
                  slot="prepend"
                  color="white"
                  @click="loadAddPessoa"
                  class="v-icon-btn"
                  large
                >
                  mdi-plus
                </v-icon>
                <v-icon
                  v-if="beneficio.solicitante"
                  slot="append"
                  color="black"
                  @click.prevent="clPessoa"
                >
                  mdi-close
                </v-icon>
              </v-text-field>
              <v-card
                v-show="listar === 'sim'"
                class="my-0 py-0"
              >
                <ul class="filtro">
                  <li
                    v-for="item in items"
                    :key="item.id"
                  >
                    <a @click="loadPedidoPessoaId( item, 'novo' )"> {{ item.solicitante }} - {{ item.cgc_txt }}</a>
                  </li>
                </ul>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="4"
              lg="3"
            >
              <v-autocomplete
                v-model="beneficio.uid_tipo_solicitacao"
                :items="solicitacoes"
                clearable
                outlined
                dense
                label="Tipo de solicitação"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="10"
            >
              <v-text-field
                v-model="beneficio.pedido"
                label="Descrição do beneficio"
                type="text"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                class="mt-0"
                v-model="beneficio.recebe_beneficio"
                label="Recebe algum beneficio?"
                color="success"
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="beneficio.descreva_beneficio"
                label="Descreva qual benefício"
                :disabled="!beneficio.recebe_beneficio"
                type="text"
                required
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="beneficio.valor"
                label="Valor"
                prefix="R$"
                required
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card flat>
            <v-card
              color="grey lighten-5"
              elevation="2"
            >
              <v-tabs
                background-color="transparent"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
                color="primary"
                v-model="tabs"
              >
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab class="mx-6">
                  <v-icon>
                    mdi-information-variant
                  </v-icon>
                  correção cpf
                </v-tab>
                <v-tab class="mx-6">
                  <v-icon>
                    mdi-information-variant
                  </v-icon>
                  Inf. adicionais
                </v-tab>
                <v-tab
                  :disabled="!isValid"
                  @click="loadTbFamilia"
                  class="mx-6"
                >
                  <v-icon class="mr-1">
                    mdi-account-cash-outline
                  </v-icon>
                  Renda familiar
                </v-tab>
                <v-tab
                  :disabled="!isValid"
                  @click="loadTbAnexo"
                >
                  <v-icon>
                    mdi-paperclip
                  </v-icon>
                  Anexos
                </v-tab>
                <v-tab
                  :disabled="!isValid"
                  @click="loadResposta"
                >
                  <v-icon>
                    mdi-forum
                  </v-icon>
                  Responder
                </v-tab>
              </v-tabs>
            </v-card>
            <hr />
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Atualização do cpf
                          <v-row>
                            <input
                              id="pessoa-cgc"
                              type="hidden"
                              v-model="pessoacpf.cgc"
                            />
                            <v-col
                              cols="12"
                              lg="4"
                              md="4"
                              sm="12"
                            >
                              <v-text-field
                                v-model="pessoacpf.cgc_txt"
                                v-mask="cpf"
                                name="cpf"
                                label="CPF"
                                type="text"
                                :class="color"
                                outlined
                                dense
                                required
                                @blur="formataCpf()"
                              >
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="2"
                              v-if="codigo"
                            >
                              <v-checkbox
                                v-model="pessoacpf.upcpf"
                                label="CPF correto?"
                                color="success"
                                v-show="mode === 'save'"
                              ></v-checkbox>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="2"
                              v-if="codigo"
                            >
                              <v-checkbox
                                v-model="pessoacpf.conta"
                                label="Conta cadastrada?"
                                color="success"
                                v-show="mode === 'save'"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            class="my-2"
                            :disabled="!btnSave"
                            @click="upCpf"
                            color="success"
                          >
                            Salvar
                          </v-btn>
                          <v-btn
                            class="ml-2"
                            color="blue-grey"
                            @click="resetcpf"
                          >
                            Limpar
                          </v-btn>
                        </v-card-actions>
                        <h1>ok pode corrigir</h1>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Informações que não foram contempladas nos ítens anteriores
                        </v-card-text>
                        <v-textarea
                          v-model="beneficio.ds_observacao"
                          label="Informações adicionais"
                          type="text"
                          outlined
                          dense
                        >
                        </v-textarea>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Informações sobre composição e renda familiar
                        </v-card-text>
                        <v-data-table
                          :headers="headersFamilia"
                          :items="familiares"
                          :search="search"
                        >
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              medium
                              color="primary"
                              class="mr-2"
                              @click="loadFamilia(item)"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                            <v-icon
                              medium
                              color="error"
                              class="mr-2"
                              @click="loadFamilia(item, 'removef')"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                            class="mb-2"
                          >
                            <v-btn
                              color="indigo"
                              dark
                              class="ml-4"
                              v-if="beneficio.id"
                              @click="adicionarFamilia"
                            >
                              <v-icon left>
                                mdi-account-multiple-plus
                              </v-icon>
                              Adicionar família
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Fotos e documentos
                        </v-card-text>
                        <v-data-table
                          :headers="headersAnexo"
                          :items="anexos"
                          item-key="id"
                          :search="search"
                          dense
                        >
                          <template v-slot:[`item.url_anexo`]="{ value }">
                            <a
                              target="_blank"
                              :href="value"
                            >
                              {{ value }}
                            </a>
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-icon
                              medium
                              color="primary"
                              class="mr-2"
                              @click="loadAnexo(item)"
                            >
                              mdi-square-edit-outline
                            </v-icon>
                            <v-icon
                              medium
                              color="error"
                              class="mr-2"
                              @click="loadAnexo(item, 'remove')"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-btn
                              color="success"
                              class="ml-4"
                              v-if="codigo"
                              @click="loadAddAnexo"
                            >
                              <v-icon left>
                                mdi-paperclip
                              </v-icon>
                              Adicionar anexo
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card
                  flat
                  class="pt-2"
                >
                  <v-row justify="space-around">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-card flat>
                        <v-card-text class="primary--text mt-1 text-v-card">
                          Informações da resposta do pedido
                        </v-card-text>
                        <hr class="hr-class mb-4" />
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-checkbox
                              class="pt-0"
                              v-model="beneficio.resposta"
                              label="Marcar como respondido?"
                              color="success"
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            cols="12"
                            md="3"
                          >
                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-mask="dta"
                                  v-model="data_resposta"
                                  label="Data de resposta.:"
                                  dense
                                  outlined
                                  @blur="mudaData"
                                >
                                  <v-icon
                                    slot="append"
                                    color="success"
                                    large
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker
                                locale="pt-br"
                                v-model="date"
                                @input="dateB"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-checkbox
                              v-model="beneficio.concluido"
                              label="Concluir pedido?"
                              color="success"
                              @change="loadConclusao"
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            v-if="beneficio.concluido"
                            cols="12"
                            md="3"
                          >
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-mask="dta1"
                                  v-model="data_conclusao"
                                  label="Data de conclusao :"
                                  dense
                                  outlined
                                  @blur="mudaData1"
                                >
                                  <v-icon
                                    slot="append"
                                    color="success"
                                    large
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker
                                locale="pt-br"
                                v-model="date1"
                                @input="dateA"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            v-if="beneficio.concluido"
                            cols="12"
                            md="4"
                          >
                            <v-autocomplete
                              v-model="beneficio.uid_situacao"
                              :items="status"
                              outlined
                              dense
                              label="Situação do processo"
                              @change="loadSaveStatus"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-textarea
                          v-model="beneficio.ds_resposta"
                          label="Descrição da resposta"
                          type="text"
                          outlined
                          dense
                        >
                        </v-textarea>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-form>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            class="mr-4"
            v-if="btnAnalize === 'analizar'"
            @click="analise()"
          >
            <v-icon left>
              mdi-magnify-scan
            </v-icon>
            Analizar
          </v-btn>
          <v-btn
            color="indigo"
            dark
            class="mr-4"
            v-if="btnAnalize === 'imprimir'"
            :href="urlRel"
            target="_blank"
          >
            <v-icon left>
              mdi-printer
            </v-icon>
            Impimir
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            v-if="mode === 'save'"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            color="teal"
            dark
            class="mr-4"
            v-if="mode === 'save'"
            @click="concluirPedido()"
          >
            <v-icon left>
              mdi-arrow-up-bold
            </v-icon>
            Eviar pedido
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            v-if="mode === 'remove'"
            @click="remove"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Deletar
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card>
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar pedidos de auxílio
              </v-toolbar>
              <v-card-title>
                <v-card-title>
                  Pesquisar
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Filtrar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
              </v-card-title>
              <v-data-table
                :headers="headersFt"
                :items="filtro"
                item-key="id"
                :search="search"
                dense
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadPedidoFilter(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    class="mr-2"
                    @click="loadPedidoFilter(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-card>
    </v-container>
    <v-container>
      <v-dialog
        v-model="addFamilia"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              <span v-if="modef === 'savef'">Adicionar pessoas e renda do seu grupo familiar</span>
              <span v-if="modef === 'removef'">Remover pessoas e renda do seu grupo familiar</span>
            </v-toolbar>
            <div class="ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="familia.usuario"
                />
                <input
                  id="familia-id"
                  type="hidden"
                  v-model="familia.id"
                />
                <input
                  id="familia-uuid"
                  type="hidden"
                  v-model="familia.uuid"
                />
                <input
                  id="beneficio-uuid"
                  type="hidden"
                  v-model="familia.uid_beneficio"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="familia.beneficiario"
                      label="Nome"
                      required
                      :disabled="modef === 'removef'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="familia.idade"
                      label="Idade"
                      required
                      :disabled="modef === 'removef'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-autocomplete
                      v-model="familia.uid_vinculo"
                      :items="parentesco"
                      required
                      clearable
                      :disabled="modef === 'removef'"
                      outlined
                      dense
                      label="Grau de parentesco"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-autocomplete
                      v-model="familia.estado_civil"
                      :items="estadoCivil"
                      required
                      :disabled="modef === 'removef'"
                      clearable
                      outlined
                      dense
                      label="Estado civil"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model="familia.ocupacao"
                      label="Ocupação atual"
                      required
                      :disabled="modef === 'removef'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <v-text-field
                      v-model="familia.renda"
                      label="Renda bruta"
                      required
                      :disabled="modef === 'removef'"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-center">
              <v-btn
                color="success"
                class="mr-4"
                v-if="modef === 'savef'"
                type="submit"
                @click="adicionarFamiliaSave"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="modef === 'savef'"
                type="submit"
                @click="adicionarFamiliaSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="modef === 'savef'"
                @click="limparFamilia"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="modef === 'removef'"
                type="submit"
                @click="removeF"
              >
                <v-icon left>
                  mdi-delete
                </v-icon>
                Remover
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="dialog.value = false"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
    <v-container class="px-5">
      <v-dialog
        v-model="addAnexo"
        transition="dialog-top-transition"
        max-width="680"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Adicionar anexo</v-toolbar>
            <div class="logo-anexo ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="anexo.usuario"
                />
                <input
                  id="anexo-id"
                  type="hidden"
                  v-model="anexo.id"
                />
                <input
                  id="anexo-uuid"
                  type="hidden"
                  v-model="anexo.uuid"
                />
                <input
                  id="uid_pedido"
                  type="hidden"
                  v-model="anexo.uid_beneficio"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      filled
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-autocomplete
                      v-model="anexo.tipo_doc"
                      :items="tipo"
                      required
                      clearable
                      filled
                      dense
                      label="Tipo de arquivo"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    v-if="btnDisable"
                  >
                    <v-checkbox
                      v-model="anexo.inativar"
                      label="Inativar anexo?"
                      color="success"
                      v-show="mode === 'save'"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <input
                    accept="image/png, image/jpeg, image/bmp, application/pdf"
                    prepend-icon="mdi-camera"
                    label="Documento ou foto em anexo"
                    v-if="uploadReady"
                    type="file"
                    ref="file"
                    @change="selectFile()"
                  >
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end py-6">
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo"
                @click="clearUpload"
              >
                Remover arquivo
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="dialog.value = false, loadClose()"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import axios from 'axios'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex'
// import { VMoney } from 'v-money'
import moment from 'moment'
import Vue from 'vue'
const { cpf } = require('cpf-cnpj-validator')
Vue.directive('money', {
  inserted (el, binding) {
    const amount = parseFloat(el.innerHTML).toFixed(2)
      .replace('.', ',')
      //    .replace(/(\d)(?=(\d{3})+,)/g, '$1.')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    el.innerHTML = `${binding.value} ${amount}`
  }
})
export default {
  name: 'Beneficios',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: ' #',
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    dta: '##/##/####',
    dta1: '##/##/####',
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_resposta: '',
    data_conclusao: '',
    btnSave: false,
    cpf: '###.###.###-##',
    color: 'null',
    menu: false,
    menu1: false,
    menuL: false,
    codigo: '',
    coduuid: '',
    tabs: null,
    uuid: '',
    mode: 'save',
    modef: 'savef',
    addAnexo: false,
    uploadReady: true,
    file: '',
    tabela: 'pessoas',
    isValid: false,
    btnAnalize: '',
    valid: true,
    dialog: false,
    addFamilia: false,
    total: 0,
    listar: '',
    beneficio: {},
    analizar: {},
    anexo: {},
    solicitante: {},
    pessoacpf: {},
    items: [],
    solicitacoes: [],
    parentesco: [],
    status: [],
    filtro: [],
    loading: false,
    search: null,
    select: null,
    headersFt: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Cpf / Cnpj', value: 'cgc' },
      { text: 'Solicitante', value: 'solicitante' },
      { text: 'Data do pedido', value: 'dataP' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    familia: {},
    familiares: [],
    headersFamilia: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'beneficiario' },
      { text: 'Idade', value: 'idade' },
      { text: 'Grau de parentesco', value: 'parentesco', sortable: false },
      { text: 'Estado Civil', value: 'estado_civil', sortable: false },
      { text: 'Ocupação', value: 'ocupacao', sortable: false },
      { text: 'Renda bruta', value: 'renda', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    anexos: [],
    headersAnexo: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url_anexo', sortable: false },
      { text: 'Tam Arq.', value: 'size_foto' },
      { text: 'Data', value: 'dataP' },
      { text: 'Situação', value: 'inativar', sortable: false, formatter: value => value ? 'Sim' : 'Não' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    estadoCivil: [
      { value: 'Solteiro', text: 'Solteiro' },
      { value: 'Casado', text: 'Casado' },
      { value: 'Divorciado', text: 'Divorciado' },
      { value: 'Viúvo', text: 'Viúvo' }
    ],
    tipo: [
      { value: 1, text: 'Documento com foto' },
      { value: 2, text: 'Comprovante de endereço' },
      { value: 3, text: 'Comprovante de renda ou outros' }
    ],
    produtos: [
      { nome: 'capacitor', preco: 10 },
      { nome: 'bobina', preco: 19 },
      { nome: 'antena', preco: 25 }
    ],
    urlRel: ''
  }),
  methods: {
    dateB () {
      this.data_resposta = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
      this.mudaData()
    },
    mudaData () {
      const [dia, mes, ano] = this.data_resposta.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      this.beneficio.data_resposta = this.date
    },
    dateA () {
      this.data_conclusao = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      this.mudaData1()
    },
    mudaData1 () {
      const [dia, mes, ano] = this.data_conclusao.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      this.beneficio.data_conclusao = this.date1
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    save () {
      const method = this.beneficio.id ? 'put' : 'post'
      const id = this.beneficio.id ? `/${this.beneficio.id}` : ''
      axios[method](`${baseApiUrl}/adm-adm-beneficios${id}`, this.beneficio)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
          this.loadUpPedido()
        })
        .catch(showError)
    },
    analise () {
      const id = this.beneficio.id
      this.analizar.uid_situacao = 3
      axios.put(`${baseApiUrl}/adm-adm-atualize/${id}`, this.analizar)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.beneficio = {}
          this.loadPedido()
        })
        .catch(showError)
    },
    concluirPedido () {
      const id = this.beneficio.id
      this.analizar.uid_situacao = 2
      axios.put(`${baseApiUrl}/adm-adm-atualize/${id}`, this.analizar)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.beneficio = {}
          this.loadPedido()
        })
        .catch(showError)
    },
    saveFamilia () {
      const method = this.familia.id ? 'put' : 'post'
      const id = this.familia.id ? `/${this.familia.id}` : ''
      axios[method](`${baseApiUrl}/beneficiarios${id}`, this.familia)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limparFamilia()
          this.loadFamiliares()
        })
        .catch(showError)
    },
    upCpf () {
      const method = 'put'
      const id = `/${this.beneficio.id}`
      axios[method](`${baseApiUrl}/beneficiarios-cpf${id}`, this.pessoacpf)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetcpf()
        })
        .catch(showError)
    },
    formataCpf () {
      const cpff = this.pessoacpf.cgc_txt
      const ccpf = cpf.isValid(cpff)
      const number = cpf.strip(cpff)
      if (ccpf === true) {
        this.pessoacpf.cgc = number
        this.color = `border: solid 1px #ced4da;`
        this.btnSave = true
      } else {
        this.color = `border: solid 1px red !important;`
      }
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/anexo-pessoas-upload`
      formData.append('uuid', this.anexo.uuid)
      formData.append('uid_pessoa', this.beneficio.uid_pessoa)
      formData.append('tipo_doc', this.anexo.tipo_doc)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.beneficio.uid_pessoa)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAnexos()
          this.resetUpload()
          this.addAnexo = false
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.anexo = {}
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
        this.loadReset()
      })
    },
    reset () {
      this.beneficio = {}
      this.familiares = []
      this.anexos = []
      this.codigo = ''
      this.coduuid = ''
      this.isValid = false
      this.beneficio.uuid = uuid.v1()
      this.beneficio.usuario = this.user.id
      this.loadDatas()
    },
    resetcpf () {
      this.pessoacpf = {}
      this.btnSave = false
      this.color = false
      this.reset()
    },
    limparFamilia () {
      this.valid = false
      this.modef = 'savef'
      this.familia = {}
      this.familia.usuario = this.user.id
      this.familia.uid_beneficio = this.beneficio.id
      this.familia.uuid = uuid.v1()
    },
    loadFiltro () {
      const url = `${baseApiUrl}/adm-adm-filtro`
      axios.get(url).then(res => {
        this.filtro = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.created_at).format('DD/MM/YYYY [às ] hh:mm')
          }
        })
      })
    },
    loadDialog () {
      this.dialog = true
      this.loadFiltro()
    },
    loadPedidoFilter (filtro, mode = 'save') {
      this.codigo = filtro.id
      this.coduuid = filtro.id
      const id = filtro.id
      const idRel = filtro.id
      this.pessoacpf.cgc = filtro.cgc
      this.pessoacpf.cgc_txt = filtro.cgc_txt
      this.mode = mode
      this.urlRel = `${baseApiUrl}/rel-beneficio-por-beneficiario/${idRel}`
      const url = `${baseApiUrl}/adm-adm-pedidos-update/${id}`
      axios.get(url).then(res => {
        this.beneficio = res.data
        this.pessoacpf.upcpf = this.beneficio.upcpf
        this.pessoacpf.conta = this.beneficio.conta
        this.dialog = false
        this.valid = true
        this.loadFamiliares()
        this.loadStatus()
        this.loadBtns()
        this.dataUpdate()
        this.formataCpf()
        if (id) {
          this.isValid = true
        }
      })
    },
    loadPedido (mode = 'save') {
      const id = this.beneficio.id ? `/${this.beneficio.id}` : `/${this.coduuid}`
      this.mode = mode
      this.codigo = id
      const url = `${baseApiUrl}/adm-adm-pedidos-update${id}`
      axios.get(url).then(res => {
        this.beneficio = res.data
        this.loadStatus()
        this.loadBtns()
        this.dataUpdate()
      })
      if (id) {
        this.isValid = true
      }
    },
    loadUpPedido (mode = 'save') {
      this.mode = mode
      const url = `${baseApiUrl}/adm-adm-beneficios-update`
      axios.get(url).then(res => {
        this.beneficio = res.data
        this.loadStatus()
        this.loadBtns()
        this.dataUpdate()
        this.isValid = true
      })
    },
    loadPedidoPessoaId (item) {
      const id = this.beneficio.uid_pessoa ? `/${this.beneficio.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/beneficiario-por-id${id}`
      axios.get(url).then(res => {
        this.solicitante = res.data
        this.beneficio.uid_pessoa = this.solicitante.uid_pessoa
        this.beneficio.uuid_pessoa = this.solicitante.uuid_pessoa
        this.beneficio.solicitante = this.solicitante.solicitante
        this.beneficio.cgc = this.solicitante.cgc
        this.beneficio.cgc_txt = this.solicitante.cgc_txt
      })
      this.clPessoa()
    },
    clPessoa () {
      this.beneficio.uid_pessoa = ''
      this.beneficio.uuid_pessoa = ''
      this.beneficio.solicitante = ''
      this.beneficio.cgc = ''
      this.beneficio.cgc_txt = ''
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.beneficio.solicitante || 0
      const url = `${baseApiUrl}/beneficiario-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFamilia (familia, modef = 'savef') {
      this.modef = modef
      this.familia = { ...familia }
      this.codigo = this.beneficio.id
      this.addFamilia = true
      this.loadParentesco()
    },
    loadTpSolicitacoes () {
      const url = `${baseApiUrl}/tipo-de-solicitacao`
      axios.get(url).then(res => {
        this.solicitacoes = res.data.map(solicitacoes => {
          return {
            value: solicitacoes.id,
            text: `${solicitacoes.tipo_solicitacao}`
          }
        })
      })
    },
    loadStatus () {
      const url = `${baseApiUrl}/adm-adm-status-situacoes-cic`
      axios.get(url).then(res => {
        this.status = res.data.map(status => {
          return {
            value: status.id,
            text: `${status.situacao}`
          }
        })
      })
    },
    loadAnexos () {
      const idA = this.beneficio.uid_pessoa
      const url = `${baseApiUrl}/documento-por-pessoa/${idA}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dataP: moment(item.created_at).format('DD/MM/YYYY [às ] hh:mm')
          }
        })
      })
    },
    loadFamiliares () {
      const idF = this.codigo
      const url = `${baseApiUrl}/beneficiarios-por-beneficio/${idF}`
      axios.get(url).then(res => {
        this.familiares = res.data
        this.total = (this.familiares.map((item) => item.renda).reduce((total, renda) => total + renda))
      })
    },
    loadParentesco () {
      const url = `${baseApiUrl}/lista-parentesco`
      axios.get(url).then(res => {
        this.parentesco = res.data.map(parentesco => {
          return {
            value: parentesco.id,
            text: `${parentesco.parentesco}`
          }
        })
      })
    },
    adicionarFamilia () {
      this.loadParentesco()
      this.familia.usuario = this.user.id
      this.familia.uid_beneficio = this.beneficio.id
      this.addFamilia = true
    },
    loadAddAnexo () {
      this.anexo.uuid = uuid.v1()
      this.anexo.usuario = this.user.id
      this.codigo = this.beneficio.id
      this.addAnexo = true
    },
    loadAnexo () {
      this.anexo.uuid = uuid.v1()
      this.anexo.usuario = this.user.id
      this.codigo = this.beneficio.id
      this.addAnexo = true
    },
    adicionarFamiliaSave () {
      this.saveFamilia()
    },
    adicionarFamiliaSair () {
      this.saveFamilia()
      this.addFamilia = false
    },
    loadTbFamilia () {
      this.loadFamiliares()
    },
    loadTbAnexo () {
      this.loadAnexos()
    },
    loadConclusao () {
      this.mode = ''
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {

    },
    blockBtn () {
      console.log('teste')
    },
    loadBtns () {
      const cod = this.codigo
      const sta = this.beneficio.uid_situacao
      if (cod && sta === 2) {
        this.btnAnalize = 'analizar'
      } else if (cod && sta >= 3) {
        this.btnAnalize = 'imprimir'
      } else {
        this.btnAnalize = ''
      }
    },
    loadSaveStatus () {
      const dt = this.beneficio.data_conclusao
      const st = this.beneficio.uid_situacao
      if (dt || st) {
        this.mode = 'save'
      }
    },
    loadResposta () {
      this.date = moment(this.beneficio.data_resposta).format('YYYY-MM-DD')
      this.data_resposta = moment(this.beneficio.data_resposta).format('DD/MM/YYYY')
      this.date1 = moment(this.beneficio.data_conclusao).format('YYYY-MM-DD')
      this.data_conclusao = moment(this.beneficio.data_conclusao).format('DD/MM/YYYY')
    },
    dataUpdate () {
      const rs = this.beneficio.resposta
      const cl = this.beneficio.concluido
      if (rs) {
        this.beneficio.data_resposta = moment(this.beneficio.data_resposta).format('YYYY-MM-DD')
      }
      if (cl) {
        this.beneficio.data_conclusao = moment(this.beneficio.data_conclusao).format('YYYY-MM-DD')
      }
      this.loadResposta()
      console.log('dataUpdate-' + rs)
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_resposta = moment(dataAgora).format('DD/MM/YYYY')
      this.data_conclusao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
      this.date1 = dataAgora
    },
    loadUser () {
      this.beneficio.uuid = uuid.v1()
      this.beneficio.usuario = this.user.id
      this.loadTpSolicitacoes()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
</style>
